import { Table, Upload } from "antd";
import styled from "styled-components";
import color from "../../../resource/color";

export const imageSize = "148px";

export const UploadBox = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: ${imageSize};
    width: ${imageSize};
  }
`;

export const UploadArea = styled.div`
  background: ${color.background1};
  border: 1px dashed ${color.Text3};
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export const QuillContainer = styled.div`
  .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0 0 !important;
  }
  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px !important;
  }
  .ql-editor {
    max-height: 80vh;
    overflow: auto;
  }
`;

export const ShopTable = styled(Table)`
  .ant-table {
    border: 1px solid ${color.border};
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    background-color: ${color.secondary} !important;
    color: ${color.white} !important;
    font-family: "IBM Plex Sans Thai", sans-serif;
    font-weight: 700 !important;
    font-size: 16px;
    padding: 12px 16px;
    border-bottom: none !important;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }
  .ant-table-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px;
  }
  .ant-table-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px;
  }
  .ant-table-tbody > tr > td {
    padding: 12px 16px;
  }
`;
